import { useAuth0 } from "@auth0/auth0-react";
import RefreshIcon from "@mui/icons-material/Refresh";
import AlertDialog from "components/Dialog/index";
import MyModal from "components/MyModal";
import Selection from "components/Selection/Selection";
import TasksSkelton from "components/Skelton/PastoralSkelton/TasksSkelton";
import PastoralService from "Lib/API/PastoralApi";
import React, { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { toastr } from "react-redux-toastr";
import Loader from "../../../components/loader/Loader";
import AssignTask from "../assignTask/assignTask";
import SnoozeModal from "../SnoozeModal/SnoozeModal";
import { taskBgColor, taskTextColor } from "./constants";
import "./styles.scss";
import Task from "./Task";

const separator = {
	Earlier: "earlier",
	Yesterday: "yesterday",
	Today: "today",
};

const EventTasks = ({
	openMemberEventDrawer,
	setCallTasksAgain,
	callTasksAgain,
	setCallFeedsAgain,
	openContactDrawerHandler,
	getEventTypesLoading,
	eventTypes,
}) => {
	const tasksRef = useRef(null);
	const { getAccessTokenSilently } = useAuth0();
	const [loading, setLoading] = useState(true);
	const [totalValue, setTotalValue] = useState(0);
	const [page, setPage] = useState(1);
	const [taskList, setTaskList] = useState([]);
	const [openAssignTaskModal, setOpenAssignTaskModal] = useState(false);
	const [openSnoozeModal, setOpenSnoozeModal] = useState(false);
	const [selectedTask, setSelectedTask] = useState(null);
	const [updateTaskLoading, setUpdateTaskLoading] = useState(false);
	const [selectedEventType, setSelectedEventType] = useState(null);
	const [openConfirmDialog, setConfirmDialog] = useState({
		open: false,
		id: null,
		loading: false,
		msg: "",
	});

	React.useEffect(() => {
		if(tasksRef?.current) {
			tasksRef.current.scrollTop = 0;
		}
		setTaskList([]);
		setPage(1);
		setTotalValue(0);
		fetchMyAPI(1);
	}, [callTasksAgain, selectedEventType]);

	const concatTaskList = (separator, list) => {
		const newTaskList = [];
		newTaskList.push({
			id: "separator",
			name: separator,
		});
		newTaskList.push(...list);
		return newTaskList;
	};

	const fetchMyAPI = async (initialPage) => {
		setLoading(true);
		const currentPage = initialPage || page;
		const token = await getAccessTokenSilently();
		PastoralService.getPastoralTasks({ token, page: currentPage, limit: 10,eventTypeId:selectedEventType?.typeId })
			.then((res) => {
				if (res) {
					const newTaskList = currentPage === 1 ? [] : [...taskList];

					const lastSeparator = newTaskList?.reduceRight((lastSeparator, item) => {
						return lastSeparator || (item?.id === "separator" ? item : null);
					}, null);
					const activeSeparator = separator[lastSeparator?.name];

					if (activeSeparator) {
						newTaskList.push(...res?.tasks?.[activeSeparator]);
					}
					const todayTasks =
						res?.tasks?.today?.length && activeSeparator !== "today" ? concatTaskList("Today", res?.tasks?.today) : [];
					const yesterdayTasks =
						res?.tasks?.yesterday?.length && activeSeparator !== "yesterday"
							? concatTaskList("Yesterday", res?.tasks?.yesterday)
							: [];
					const earlierTasks =
						res?.tasks?.earlier?.length && activeSeparator !== "earlier"
							? concatTaskList("Earlier", res?.tasks?.earlier)
							: [];
					newTaskList.push(...todayTasks, ...yesterdayTasks, ...earlierTasks);

					setTaskList(newTaskList);
					setTotalValue(res?.total);
					setPage((prevPage) => prevPage + 1);
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setLoading(false);
			});
	};
	
	const openAssignTaskModalHandler = (data) => {
		setOpenAssignTaskModal(true);
		setSelectedTask(data);
	};

	const closeAssignTaskModalHandler = () => {
		setOpenAssignTaskModal(false);
		setSelectedTask(null);
	};

	const openSnoozeModalHandler = (data) => {
		setOpenSnoozeModal(true);
		setSelectedTask(data);
	};

	const closeSnoozeModalHandler = () => {
		setOpenSnoozeModal(false);
		setSelectedTask(null);
	};

	const updateTaskHandler = async ({ id, key, assignValue, snoozeValue, successMsg }) => {
		setUpdateTaskLoading(true);
		let payload = {
			status: key,
		};
		if (assignValue) {
			payload = {
				...payload,
				assignTo: assignValue,
			};
		}
		if (snoozeValue) {
			payload = {
				...payload,
				snoozeTo: snoozeValue,
			};
		}
		if(key === 3) {
			setConfirmDialog(prevState => ({
				...prevState,
				loading: true,
			}));
		}
		const token = await getAccessTokenSilently();
		PastoralService.updateTask({ taskId: id, token, data: payload })
			.then((res) => {
				if (res) {
					toastr.success(successMsg || "Action completed");
					setCallTasksAgain((prevState) => !prevState);
					setCallFeedsAgain((prevState) => !prevState);
					if (assignValue) {
						closeAssignTaskModalHandler();
					}
					if (snoozeValue) {
						closeSnoozeModalHandler();
					}
				}
			})
			.catch((err) => {
				toastr.error("Error", err?.data?.message || "Something went wrong");
			})
			.finally(() => {
				setUpdateTaskLoading(false);
				setConfirmDialog(prevState => ({
					...prevState,
					loading: false,
					open: false,
				}));
			});
	};

	const options =
		eventTypes &&
		eventTypes?.map((item) => {
			return {
				label: item?.name,
				typeId: item?.id,
			};
		});


	const closeDeleteDialog = () => {
		setConfirmDialog(prevState => ({
			...prevState,
			open: false,
		}));
	}

	const onDeleteTask = (id) => {
		setConfirmDialog(prevState => ({
			...prevState,
			open: true,
			id: id,
		}));
	}

	const deleteHandler = () => {
		updateTaskHandler({
			key: 3,
			id: openConfirmDialog.id,
			successMsg: "Task deleted Successfully",
		});
	}

	return (
		<div className="event-tasks w-100">
			<div className="tasks-h d-flex justify-content-between align-items-start mb-5">
				<div className="d-flex align-items-center">
					<p className="m-0 font-16">Uncompleted Tasks</p>
					<div className="tasks-badge d-flex align-items-center justify-content-center">{totalValue}</div>
				</div>
				<div
					className="pastoral__refresh-icon cursor-pointer"
					onClick={() => {
						setCallTasksAgain((prevState) => !prevState);
					}}
				>
					<RefreshIcon
						className="svg-icon"
						sx={{
							color: "#4D5565",
							width: "20px",
						}}
					/>
				</div>
			</div>
			<div className="form-group event-type-newEvent w-100">
				<Selection
					name="eventType"
					mandatory={true}
					placeholder="Select Event Type"
					options={options}
					isLoading={getEventTypesLoading}
					onChange={(value) => {
						if (!value) {
							setSelectedEventType(null);
							return;
						}
						setSelectedEventType({
							typeId: value.typeId,
							name: value.label,
						});
					}}
					value={
						selectedEventType
							? {
									label: selectedEventType?.name,
									typeId: selectedEventType?.typeId,
							  }
							: null
					}
					isClearable={selectedEventType}
				/>
			</div>
			<div className="p-2" style={{ background: "white" }}>
			<div className="" >
					<div className="tasks-body tasks-scroll p-3" ref={tasksRef} id="event-task-wrapper">
						<div> 
							<br />
							{totalValue === 0 && !loading && <h3 className="text-center mt-5">No Data</h3>}
							{(loading && totalValue === 0 ) ? (
								<TasksSkelton length={6} />
							) : (
								<>
									<InfiniteScroll
										scrollableTarget="event-task-wrapper"
										dataLength={taskList.length}
										next={fetchMyAPI}
										hasMore={taskList?.length < totalValue}
										loader={
											<TasksSkelton length={1} />
										}
									>
										{taskList &&
										taskList?.map((item) => {
											if (item.id === "separator") {
												return <p className="new font-14 mb-2">{item.name}</p>;
											} else {
												return (
													<Task
														taskData={item}
														key={item.id}
														setCallAgain={setCallTasksAgain}
														data={item}
														firstName={item?.RLfname}
														lastName={item?.RLlname}
														taskTitle={item.name}
														taskDes={item.descreption?.toLowerCase() === "todo" ? "Task" : item.descreption}
														taskAvatar={item.avtar}
														subject={item?.subject}
														content={item?.["Sagestion text"]}
														email={item?.email}
														phone={item?.mobile}
														date={item?.added}
														dateType={item?.dateType}
														taskBackground={
															item?.descreption?.toLowerCase() === "todo"
																? taskBgColor["todo"]
																: taskBgColor[item?.dateType?.toLowerCase()]
														}
														taskColor={
															item?.descreption?.toLowerCase() === "todo"
																? taskTextColor["todo"]
																: taskTextColor[item?.dateType?.toLowerCase()]
														}
														openAssignTaskModalHandler={openAssignTaskModalHandler}
														openSnoozeModalHandler={openSnoozeModalHandler}
														updateTaskHandler={updateTaskHandler}
														suggestionText={item?.["Sagestion text"]}
														onContactClick={() => openContactDrawerHandler(item)}
														onEventClick={() => openMemberEventDrawer(item)}
														onDeleteTask={onDeleteTask}
													/>
												);
											}
										})}
									</InfiniteScroll>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
			<MyModal className="pastoral-assign-task-modal" open={openAssignTaskModal} onClose={closeAssignTaskModalHandler}>
				<AssignTask
					closeModal={closeAssignTaskModalHandler}
					updateTaskHandler={updateTaskHandler}
					selectedTask={selectedTask}
					updateTaskLoading={updateTaskLoading}
				/>
			</MyModal>
			<MyModal className="pastoral-snooze-modal" open={openSnoozeModal} onClose={closeSnoozeModalHandler}>
				<SnoozeModal
					closeModal={closeSnoozeModalHandler}
					updateTaskHandler={updateTaskHandler}
					selectedTask={selectedTask}
					updateTaskLoading={updateTaskLoading}
				/>
			</MyModal>
			<AlertDialog
				open={openConfirmDialog.open}
				onDecline={closeDeleteDialog}
				onAccept={() => {
					if (openConfirmDialog?.id) {
						deleteHandler();
					}
				}}
				title={"Are you sure?"}
				description={"Do you want to delete this task?"}
				disabled={openConfirmDialog.loading}
			/>
		</div>
	);
};

export default EventTasks;
